import { render, staticRenderFns } from "./Hi.vue?vue&type=template&id=c0ab169c&"
import script from "./Hi.vue?vue&type=script&lang=js&"
export * from "./Hi.vue?vue&type=script&lang=js&"
import style0 from "./Hi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports